import axios from 'axios';

// Helper per ottenere il token di autenticazione
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Configurazione di base per le chiamate API protette da admin
const api = axios.create({
  baseURL: '/api/admin/access-codes',
});

// Aggiungiamo il token a ogni richiesta
api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// --- Funzioni del Servizio ---

export const getAllAccessCodes = async () => {
  const response = await api.get('/');
  return response.data;
};

export const createAccessCode = async (description) => {
  const response = await api.post('/', { description });
  return response.data;
};

// Usata per attivare/disattivare un codice
export const updateAccessCode = async (id, data) => {
  const response = await api.put(`/${id}`, data);
  return response.data;
};

export const deleteAccessCode = async (id) => {
  await api.delete(`/${id}`);
};